var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "LessonEntityDetails__Component" },
    [
      _c("FieldInlineText", {
        attrs: { label: "תווית יחידה" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.unitDisplayName,
          callback: function ($$v) {
            _vm.$set(_vm.model, "unitDisplayName", $$v)
          },
          expression: "model.unitDisplayName",
        },
      }),
      _c(
        "b-field",
        { attrs: { label: "שאלה" } },
        [
          _c("NewActivityEditor", {
            ref: "editor",
            attrs: {
              ckEditorContent: _vm.model.question,
              content: _vm.model.question,
            },
            on: { onEditorChange: _vm.onEditorChange },
          }),
        ],
        1
      ),
      _c("FieldInlineSelect", {
        attrs: {
          label: "תשובה",
          filterable: false,
          clearable: false,
          options: [
            { Value: true, Text: "נכון" },
            { Value: false, Text: "לא נכון" },
          ],
          required: "true",
        },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.answer,
          callback: function ($$v) {
            _vm.$set(_vm.model, "answer", $$v)
          },
          expression: "model.answer",
        },
      }),
      _c("FieldInlineText", {
        attrs: { label: "פתרון" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.detailedAnswer,
          callback: function ($$v) {
            _vm.$set(_vm.model, "detailedAnswer", $$v)
          },
          expression: "model.detailedAnswer",
        },
      }),
      _c("FieldInlineText", {
        attrs: { label: "רמת קושי", type: "number" },
        on: { onChange: _vm.onChange },
        model: {
          value: _vm.model.level,
          callback: function ($$v) {
            _vm.$set(_vm.model, "level", $$v)
          },
          expression: "model.level",
        },
      }),
      _c(
        "div",
        { staticClass: "checkbox-container" },
        [
          _c(
            "b-switch",
            {
              staticClass: "ltr",
              on: { input: _vm.onChange },
              model: {
                value: _vm.model.status,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "status", $$v)
                },
                expression: "model.status",
              },
            },
            [_vm._v(_vm._s(_vm.model.status ? "פעיל" : "לא פעיל"))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }